export default __webpack_public_path__ + "static/media/Compounding Returns Over Time.41410a8a.png";